// extracted by mini-css-extract-plugin
export default {"viewer":"structure-viewer_viewer__S+IZz"};